/*
 * @Author: 王一宁 wangyining@fenxiangbuy.com
 * @Date: 2024-08-06 14:42:08
 * @LastEditors: 王一宁 wangyining@fenxiangbuy.com
 * @LastEditTime: 2024-08-06 17:05:40
 * @FilePath: /shengsheng-client/src/api/request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "axios";
import qs from "qs";
import CryptoJS from "crypto-js";

// 创建一个实例
const api = axios.create({
  baseURL: "/api",
  timeout: 5000,
});

// 封装 GET 请求方法
export const get = (url, params = {}) => {
  return api.get(url, {
    params,
    headers: {
      "x-access-token": localStorage.getItem("smileOrderSessionId") || "",
    },
  });
};

// 封装 POST 请求方法
export const post = (url, data = {}, config = { isJSON: false }) => {
  console.log("🚀 ~ post ~ config:", config);
  data = deepClone(data);
  var timestamp = new Date().getTime();
  data.timestamp = timestamp.toString();
  var param = deepClone(data);
  var sign = getSign(param);
  var signStr = "";
  for (var key in sign) {
    signStr += key + "=" + sign[key] + "&";
  }
  signStr = md5(signStr);
  signStr = signStr.substring(0, 8);
  data.sign = signStr;

  // 判断是否使用 JSON 格式
  const isJson = config.isJSON;
  console.log("🚀 ~ post ~ isJson:", isJson);

  // 设置默认 headers
  const defaultHeaders = isJson
    ? { "Content-Type": "application/json" }
    : { "Content-Type": "application/x-www-form-urlencoded" };

  // 根据 content-type 决定数据格式
  const requestData = isJson ? JSON.stringify(data) : qs.stringify(data);

  return api({
    url: url,
    method: "post",
    headers: {
      ...defaultHeaders,
      "x-access-token": localStorage.getItem("smileOrderSessionId") || "",
    },
    data: requestData,
  });
};

function md5(word) {
  return CryptoJS.MD5(word).toString();
}

const getSign = function (params) {
  var newkey = Object.keys(params).sort();
  var newObj = {};
  for (var i = 0; i < newkey.length; i++) {
    newObj[newkey[i]] = params[newkey[i]];
  }
  return newObj;
};
export const deepClone = function (source) {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments", "shallowClone");
  }
  const targetObj = source.constructor === Array ? [] : {};
  for (const keys in source) {
    if (Object.prototype.hasOwnProperty.call(source, keys)) {
      if (source[keys] && typeof source[keys] === "object") {
        targetObj[keys] = source[keys].constructor === Array ? [] : {};
        targetObj[keys] = deepClone(source[keys]);
      } else {
        targetObj[keys] = source[keys];
      }
    }
  }
  return targetObj;
};
